const ELASTIC_SEARCH_TEST_CONFIG_KEY = 'vf_elastic_search_test_config';
const ELASTIC_SEARCH_TEST_CONFIG_ENABLED_KEY = 'vf_elastic_search_test_config_enabled';

export const loadTestConfigFromStorage = () => {
  try {
    const savedConfig = localStorage.getItem(ELASTIC_SEARCH_TEST_CONFIG_KEY);
    const savedEnabled = localStorage.getItem(ELASTIC_SEARCH_TEST_CONFIG_ENABLED_KEY);
    
    return {
      testConfig: savedConfig ? JSON.parse(savedConfig) : null,
      testConfigEnabled: savedEnabled ? JSON.parse(savedEnabled) : false,
    };
  } catch (error) {
    console.warn('Failed to load ElasticSearch test config from localStorage:', error);
    return {
      testConfig: null,
      testConfigEnabled: false,
    };
  }
};

export const saveTestConfigToStorage = (testConfig) => {
  try {
    localStorage.setItem(ELASTIC_SEARCH_TEST_CONFIG_KEY, JSON.stringify(testConfig));
  } catch (error) {
    console.warn('Failed to save ElasticSearch test config to localStorage:', error);
  }
};

export const saveTestConfigEnabledToStorage = (enabled) => {
  try {
    localStorage.setItem(ELASTIC_SEARCH_TEST_CONFIG_ENABLED_KEY, JSON.stringify(enabled));
  } catch (error) {
    console.warn('Failed to save ElasticSearch test config enabled state to localStorage:', error);
  }
};

export const clearTestConfigFromStorage = () => {
  try {
    localStorage.removeItem(ELASTIC_SEARCH_TEST_CONFIG_KEY);
    localStorage.removeItem(ELASTIC_SEARCH_TEST_CONFIG_ENABLED_KEY);
  } catch (error) {
    console.warn('Failed to clear ElasticSearch test config from localStorage:', error);
  }
};
